import React from 'react';
import { 
  Card, 
  Typography, 
  Container, 
  Grid, 
  Box, 
  Chip
} from '@mui/material';
import { 
  AllInclusive, 
  LocationOn, 
  AccessTime, 
  QrCode, 
  Security, 
  CreditCard, 
  Star 
} from '@mui/icons-material';

const benefits = [
  {
    icon: AllInclusive,
    title: "Lavagens Ilimitadas",
    description: "Lave seu carro quantas vezes quiser durante o mês. Sem limite de uso.",
    highlight: true
  },
  {
    icon: LocationOn,
    title: "Rede Qualificada",
    description: "Mais de 500 parceiros credenciados em todo o Brasil com padrão de qualidade garantido.",
    highlight: false
  },
  {
    icon: AccessTime,
    title: "Economia de Tempo",
    description: "Sem filas, sem espera. Encontre o parceiro mais próximo e tenha prioridade no atendimento.",
    highlight: false
  },
  {
    icon: QrCode,
    title: "Validação Simples",
    description: "Apenas escaneie o QR Code no estabelecimento e pronto. Processo 100% digital.",
    highlight: false
  },
  {
    icon: CreditCard,
    title: "Pagamento Automático",
    description: "Cobrança mensal no cartão. Cancele quando quiser pelo próprio app.",
    highlight: false
  },
  {
    icon: Security,
    title: "Garantia Total",
    description: "Satisfação garantida ou seu dinheiro de volta. Suporte 24/7 pelo app.",
    highlight: false
  }
];

const BenefitsSection = () => {
  return (
    <section id="vantagens" className="section-spacing bg-background">
      <Container maxWidth="lg">
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 6 }} className="component-spacing">
          <Chip
            icon={<Star />}
            label="POR QUE ESCOLHER O WASHPASS"
            sx={{
              backgroundColor: 'rgba(6, 182, 212, 0.1)',
              color: '#06b6d4',
              fontWeight: 600,
              mb: 2
            }}
          />
          <Typography 
            variant="h2" 
            className="text-section"
            sx={{ 
              color: '#1a202c', 
              mb: 2,
              fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' },
              fontWeight: 700
            }}
          >
            Benefícios que fazem a diferença
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: '#64748b', 
              maxWidth: '600px', 
              mx: 'auto' 
            }}
          >
            Mais de 50.000 usuários já descobriram uma forma mais inteligente 
            de cuidar do seu carro. Seja o próximo!
          </Typography>
        </Box>

        {/* Benefits Grid */}
        <Grid container spacing={3} sx={{ alignItems: 'stretch' }}>
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Grid item xs={12} md={6} lg={4} key={index} sx={{ display: 'flex' }}>
                <Card
                  sx={{
                    p: 3,
                    boxShadow: benefit.highlight 
                      ? '0 8px 30px rgba(6, 182, 212, 0.15)' 
                      : '0 4px 20px rgba(30, 58, 138, 0.1)',
                    background: benefit.highlight 
                      ? 'linear-gradient(145deg, rgba(6, 182, 212, 0.05) 0%, transparent 100%)'
                      : 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                    border: benefit.highlight ? '2px solid rgba(6, 182, 212, 0.2)' : '1px solid #e2e8f0',
                    transition: 'all 0.3s ease',
                    borderRadius: '10px',
                    flex: 1, // Ocupa toda a altura disponível do Grid item
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      boxShadow: '0 8px 30px rgba(30, 58, 138, 0.15)',
                      transform: 'translateY(-4px)'
                    }
                  }}
                >
                  <Box sx={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Box
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 2,
                        backgroundColor: benefit.highlight ? '#06b6d4' : 'rgba(6, 182, 212, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'scale(1.1)'
                        }
                      }}
                    >
                      <Icon 
                        sx={{ 
                          color: benefit.highlight ? 'white' : '#06b6d4', 
                          width: 32, 
                          height: 32 
                        }} 
                      />
                    </Box>
                    
                    <Typography 
                      variant="h5" 
                      sx={{ 
                        fontWeight: 600, 
                        color: '#1a202c', 
                        mb: 1.5 
                      }}
                    >
                      {benefit.title}
                    </Typography>
                    
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: '#64748b', 
                        lineHeight: 1.6,
                        flex: 1
                      }}
                    >
                      {benefit.description}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </section>
  );
};

export default BenefitsSection;
